import TurboCacheAware from "./turbo_cache_aware"

// Wraps bootstrap-datepicker on a single input. Reused across
// customer_orders/_form, customer_orders/search and customer_orders/screener,
// each passing its own date format via the format value.
//
// Extends TurboCacheAware (see that file): destroying the plugin has to
// happen before Turbo caches the page for back/forward navigation, not
// only in disconnect(), or a restored cache snapshot reconnects this
// controller to an input the plugin (and jQuery's own $.data() on it)
// still thinks is already initialized.
export default class extends TurboCacheAware {
  static values = {
    format: { type: String, default: "yyyy-mm-dd" },
    autoclose: { type: Boolean, default: true },
  }

  connect() {
    $(this.element).datepicker({
      format: this.formatValue,
      autoclose: this.autocloseValue,
    })

    this.cleanupOnCache(() => $(this.element).datepicker("destroy"))
  }
}
